(function () {
  'use strict';

  console.log('[QV Swipe Stable] init');

  var CONFIG = {
    modalSelector: '[data-quick-product-modal]',
    contentSelector: '.quick-product-modal__content',
    mediaRootSelector: '.product__media',
    mediaItemSelector: '.product__media-item[data-product-media-wrapper][data-media-item-id]',

    thumbSelector: '[data-product-thumbnail][data-thumbnail-id]',

    minDistance: 35,
    maxVerticalRatio: 1,
    clickTolerance: 8
  };

  var state = {
    active: false,
    mediaRoot: null,
    startX: 0,
    startY: 0,
    moved: false
  };

  function getMediaRoot(target) {
    if (!target || !target.closest) return null;

    var modal = target.closest(CONFIG.modalSelector);
    if (!modal) return null;

    var content = modal.querySelector(CONFIG.contentSelector);
    if (!content) return null;

    var mediaRoot = target.closest(CONFIG.mediaRootSelector);
    if (!mediaRoot) return null;

    if (!content.contains(mediaRoot)) return null;

    return mediaRoot;
  }

  function getItems(mediaRoot) {
    return Array.prototype.slice.call(
      mediaRoot.querySelectorAll(CONFIG.mediaItemSelector)
    );
  }

  function getCurrentIndex(items) {
    for (var i = 0; i < items.length; i++) {
      if (!items[i].classList.contains('hidden')) {
        return i;
      }
    }

    return 0;
  }

  function updateThumbActive(mediaRoot, targetMediaId) {
    var modal = mediaRoot.closest(CONFIG.modalSelector);
    if (!modal) return;

    var thumbs = modal.querySelectorAll(CONFIG.thumbSelector);

    Array.prototype.forEach.call(thumbs, function (thumb) {
      var isActive = thumb.getAttribute('data-thumbnail-id') === String(targetMediaId);

      if (isActive) {
        thumb.classList.add('active');
        thumb.setAttribute('aria-current', 'true');
        thumb.setAttribute('aria-selected', 'true');
      } else {
        thumb.classList.remove('active');
        thumb.removeAttribute('aria-current');
        thumb.removeAttribute('aria-selected');
      }
    });
  }

  function showItem(mediaRoot, targetIndex) {
    var items = getItems(mediaRoot);

    if (items.length <= 1) return;

    if (targetIndex < 0) {
      targetIndex = items.length - 1;
    }

    if (targetIndex >= items.length) {
      targetIndex = 0;
    }

    var targetItem = items[targetIndex];
    var targetMediaId = targetItem.getAttribute('data-media-item-id');

    items.forEach(function (item, index) {
      if (index === targetIndex) {
        item.classList.remove('hidden');
        item.removeAttribute('hidden');
        item.setAttribute('aria-hidden', 'false');

        var imageWrap = item.querySelector('.image');
        if (imageWrap) {
          imageWrap.classList.add('loaded');
        }
      } else {
        item.classList.add('hidden');
        item.setAttribute('aria-hidden', 'true');
      }
    });

    updateThumbActive(mediaRoot, targetMediaId);

    console.log('[QV Swipe] switched to:', targetIndex, targetMediaId);
  }

  function move(mediaRoot, direction) {
    var items = getItems(mediaRoot);

    if (items.length <= 1) return;

    var currentIndex = getCurrentIndex(items);
    var targetIndex = direction === 'next'
      ? currentIndex + 1
      : currentIndex - 1;

    showItem(mediaRoot, targetIndex);
  }

  document.addEventListener('touchstart', function (event) {
    if (!event.touches || event.touches.length !== 1) return;

    var mediaRoot = getMediaRoot(event.target);
    if (!mediaRoot) return;

    var items = getItems(mediaRoot);
    if (items.length <= 1) return;

    state.active = true;
    state.mediaRoot = mediaRoot;
    state.startX = event.touches[0].clientX;
    state.startY = event.touches[0].clientY;
    state.moved = false;
  }, { passive: true, capture: true });

  document.addEventListener('touchmove', function (event) {
    if (!state.active || !state.mediaRoot) return;
    if (!event.touches || event.touches.length !== 1) return;

    var dx = event.touches[0].clientX - state.startX;
    var dy = event.touches[0].clientY - state.startY;

    if (Math.abs(dx) > CONFIG.clickTolerance || Math.abs(dy) > CONFIG.clickTolerance) {
      state.moved = true;
    }
  }, { passive: true, capture: true });

  document.addEventListener('touchend', function (event) {
    if (!state.active || !state.mediaRoot) return;
    if (!event.changedTouches || event.changedTouches.length !== 1) return;

    var mediaRoot = state.mediaRoot;

    var dx = event.changedTouches[0].clientX - state.startX;
    var dy = event.changedTouches[0].clientY - state.startY;

    state.active = false;
    state.mediaRoot = null;

    if (!state.moved) return;

    if (Math.abs(dy) > Math.abs(dx) * CONFIG.maxVerticalRatio) return;

    if (Math.abs(dx) < CONFIG.minDistance) return;

    if (dx < 0) {
      move(mediaRoot, 'next');
    } else {
      move(mediaRoot, 'prev');
    }
  }, { passive: true, capture: true });

  document.addEventListener('touchcancel', function () {
    state.active = false;
    state.mediaRoot = null;
    state.moved = false;
  }, { passive: true, capture: true });
})();

(function () {
  'use strict';
  if (window.LH_FLOATING_SYSTEM_INIT) return;
  window.LH_FLOATING_SYSTEM_INIT = true;

  var MOBILE_MAX_WIDTH = 767;

  function isMobile() {
    return window.innerWidth <= MOBILE_MAX_WIDTH;
  }

  // =========================
  // Floating ATC
  // =========================
  function getBarHeight(bar) {
    return Math.ceil(bar.getBoundingClientRect().height || 0);
  }

  function isOriginalPositionVisible(anchor, bar) {
    var height = getBarHeight(bar) || 80;
    var rect = anchor.getBoundingClientRect();

    var top = rect.top;
    var bottom = rect.top + height;

    return bottom > 0 && top < window.innerHeight;
  }

  function resetFloating(anchor, bar) {
    anchor.style.height = '0px';
    bar.classList.remove('is-lh-floating-atc');
    document.body.classList.remove('lh-floating-atc-active');
    document.body.style.removeProperty('--lh-floating-atc-height');
  }

  function updateFloatingBar(anchor, bar) {
    if (!isMobile()) {
      resetFloating(anchor, bar);
      return;
    }

    var shouldFloat = !isOriginalPositionVisible(anchor, bar);
    var height = getBarHeight(bar) || 80;

    if (shouldFloat) {
      anchor.style.height = height + 'px';
      bar.classList.add('is-lh-floating-atc');
      document.body.classList.add('lh-floating-atc-active');
      document.body.style.setProperty('--lh-floating-atc-height', height + 'px');
    } else {
      resetFloating(anchor, bar);
    }
  }

  function initFloatingAtc() {
    var bars = document.querySelectorAll('[data-lh-floating-atc-bar]');

    bars.forEach(function (bar) {
      if (bar.dataset.lhFloatingAtcBound === 'true') return;
      bar.dataset.lhFloatingAtcBound = 'true';

      var form = bar.closest('[data-product-form], form');
      if (!form) return;

      var anchor = form.querySelector('[data-lh-floating-atc-anchor]');
      if (!anchor) return;

      var ticking = false;

      function requestUpdate() {
        if (ticking) return;

        ticking = true;

        requestAnimationFrame(function () {
          updateFloatingBar(anchor, bar);
          ticking = false;
        });
      }

      requestUpdate();

      window.addEventListener('scroll', requestUpdate, { passive: true });
      window.addEventListener('resize', requestUpdate);

      if (window.ResizeObserver) {
        new ResizeObserver(requestUpdate).observe(bar);
      }
    });
  }

  // =========================
  // Floating Variant Sync
  // =========================
  function getProductVariants(form) {
    var json = form.querySelector('[data-lh-product-variants-json]');
    if (!json) return [];

    try {
      return JSON.parse(json.textContent || '[]');
    } catch (e) {
      return [];
    }
  }

  function getFloatingOptionSelects(form) {
    return Array.prototype.slice.call(
      form.querySelectorAll('.lh-floating-select[data-option-position]')
    ).sort(function (a, b) {
      return Number(a.getAttribute('data-option-position')) - Number(b.getAttribute('data-option-position'));
    });
  }

  function findVariantBySelectedOptions(variants, optionValues) {
    return variants.find(function (variant) {
      if (!variant.options) return false;

      return optionValues.every(function (value, index) {
        return String(variant.options[index]) === String(value);
      });
    });
  }

  function getSelectedFloatingVariant(form) {
    var variants = getProductVariants(form);
    var optionSelects = getFloatingOptionSelects(form);

    if (!variants.length || !optionSelects.length) return null;

    var optionValues = optionSelects.map(function (select) {
      return select.value;
    });

    return findVariantBySelectedOptions(variants, optionValues);
  }

  function updateAddButtonState(form, variant) {
    var button = form.querySelector('[data-add-to-cart]');
    if (!button) return;

    var text = button.querySelector('[data-add-to-cart-text]');
    var availableText = button.getAttribute('data-lang-available') || 'Add to cart';
    var soldOutText = button.getAttribute('data-lang-sold-out') || 'Sold out';
    var unavailableText = button.getAttribute('data-lang-unavailable') || 'Unavailable';

    if (!variant) {
      button.disabled = true;
      button.setAttribute('aria-disabled', 'true');
      button.setAttribute('aria-label', unavailableText);
      if (text) text.textContent = unavailableText;
      return;
    }

    if (variant.available) {
      button.disabled = false;
      button.removeAttribute('aria-disabled');
      button.setAttribute('aria-label', availableText);
      if (text) text.textContent = availableText;
    } else {
      button.disabled = true;
      button.setAttribute('aria-disabled', 'true');
      button.setAttribute('aria-label', soldOutText);
      if (text) text.textContent = soldOutText;
    }
  }

  function forceVariantIdToForm(form, variant) {
    if (!form || !variant || !variant.id) return;

    var variantId = String(variant.id);
    var idFields = form.querySelectorAll('[name="id"]');

    idFields.forEach(function (field) {
      field.value = variantId;
      field.dispatchEvent(new Event('input', { bubbles: true }));
      field.dispatchEvent(new Event('change', { bubbles: true }));
    });

    if (!idFields.length) {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'id';
      input.value = variantId;
      input.setAttribute('data-lh-forced-variant-id', 'true');
      form.appendChild(input);
    }

    form.setAttribute('data-current-product-id', variantId);

    form.dispatchEvent(new Event('change', { bubbles: true }));

    form.dispatchEvent(new CustomEvent('variant:change', {
      bubbles: true,
      detail: {
        variant: variant
      }
    }));
  }

  function applySelectedFloatingVariant(form) {
    var variant = getSelectedFloatingVariant(form);

    forceVariantIdToForm(form, variant);
    updateAddButtonState(form, variant);

    return variant;
  }

  function initFloatingVariantSelect() {
    var forms = document.querySelectorAll('[data-product-form]');

    forms.forEach(function (form) {
      if (form.dataset.lhFloatingVariantBound === 'true') return;
      form.dataset.lhFloatingVariantBound = 'true';

      var optionSelects = getFloatingOptionSelects(form);
      if (!optionSelects.length) return;

      optionSelects.forEach(function (select) {
        select.addEventListener('change', function () {
          applySelectedFloatingVariant(form);
        });
      });

      applySelectedFloatingVariant(form);
    });
  }

  // =========================
  // Ajax Add To Cart + Reload
  // =========================
  function getCartAddUrl() {
    if (window.routes && window.routes.cartAddUrl) {
      return window.routes.cartAddUrl + '.js';
    }

    if (window.Shopify && Shopify.routes && Shopify.routes.root) {
      return Shopify.routes.root + 'cart/add.js';
    }

    return '/cart/add.js';
  }

  function getQuantityFromForm(form) {
    var quantityInput = form.querySelector('[name="quantity"]');

    if (!quantityInput) return 1;

    var quantity = Number(quantityInput.value || 1);

    if (!quantity || quantity < 1) {
      quantity = 1;
    }

    return quantity;
  }

  function addFloatingVariantToCart(form, button) {
    var variant = getSelectedFloatingVariant(form);

    if (!variant || !variant.id || variant.available === false) {
      updateAddButtonState(form, variant);
      return;
    }

    forceVariantIdToForm(form, variant);

    var quantity = getQuantityFromForm(form);

    button.disabled = true;
    button.setAttribute('aria-disabled', 'true');
    document.dispatchEvent(new CustomEvent('theme:loading:start'));

    fetch(getCartAddUrl(), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        items: [
          {
            id: Number(variant.id),
            quantity: quantity
          }
        ]
      })
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Floating add to cart failed');
        }

        return response.json();
      })
      .then(function () {
        window.location.reload();
      })
      .catch(function () {
        forceVariantIdToForm(form, variant);
        form.submit();
      })
      .finally(function () {
        button.disabled = false;
        button.removeAttribute('aria-disabled');
        document.dispatchEvent(new CustomEvent('theme:loading:end'));
      });
  }

  function initFloatingDirectAdd() {
    if (window.LH_FLOATING_DIRECT_ADD_INIT) return;
    window.LH_FLOATING_DIRECT_ADD_INIT = true;

    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-add-to-cart]');
      if (!button) return;

      var form = button.closest('[data-product-form], form');
      if (!form) return;

      var bar = button.closest('[data-lh-floating-atc-bar]');
      if (!bar || !bar.classList.contains('is-lh-floating-atc')) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      addFloatingVariantToCart(form, button);
    }, true);
  }

  function initFloatingPrettySelects() {
  if (window.LH_FLOATING_PRETTY_SELECT_INIT) return;
  window.LH_FLOATING_PRETTY_SELECT_INIT = true;

  function closeAll(except) {
    document.querySelectorAll('.lh-floating-custom-select.is-open').forEach(function (wrap) {
      if (wrap !== except) {
        wrap.classList.remove('is-open');
      }
    });
  }

  document.querySelectorAll('.lh-floating-select[data-option-position]').forEach(function (select) {
    if (select.dataset.lhPrettySelect === 'true') return;
    select.dataset.lhPrettySelect = 'true';

    var wrapper = document.createElement('div');
    wrapper.className = 'lh-floating-custom-select';

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'lh-floating-custom-select__button';

    var list = document.createElement('div');
    list.className = 'lh-floating-custom-select__list';

    function updateButtonText() {
      var selectedOption = select.options[select.selectedIndex];
      button.textContent = selectedOption ? selectedOption.textContent : '';
    }

    function rebuildOptions() {
      list.innerHTML = '';

      Array.prototype.slice.call(select.options).forEach(function (option) {
        var item = document.createElement('button');
        item.type = 'button';
        item.className = 'lh-floating-custom-select__option';
        item.textContent = option.textContent;
        item.setAttribute('data-value', option.value);

        if (String(option.value) === String(select.value)) {
          item.classList.add('is-selected');
        }

        item.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();

          select.value = option.value;

          select.dispatchEvent(new Event('input', { bubbles: true }));
          select.dispatchEvent(new Event('change', { bubbles: true }));

          wrapper.classList.remove('is-open');
          updateButtonText();
          rebuildOptions();
        });

        list.appendChild(item);
      });
    }

    select.parentNode.insertBefore(wrapper, select);
    wrapper.appendChild(select);
    wrapper.appendChild(button);
    wrapper.appendChild(list);

    updateButtonText();
    rebuildOptions();

    button.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();

      var willOpen = !wrapper.classList.contains('is-open');

      closeAll(wrapper);

      if (willOpen) {
        wrapper.classList.add('is-open');
      }
    });

    select.addEventListener('change', function () {
      updateButtonText();
      rebuildOptions();
    });
  });

  document.addEventListener('click', function () {
    closeAll();
  });
}

  // =========================
  // Init
  // =========================
  function initAll() {
    initFloatingAtc();
    initFloatingVariantSelect();
    initFloatingPrettySelects();

    initFloatingDirectAdd();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function () {
    initAll();
  });
})();